import { render, staticRenderFns } from "./live-reply.vue?vue&type=template&id=2e585745&scoped=true"
import script from "./live-reply.vue?vue&type=script&lang=js"
export * from "./live-reply.vue?vue&type=script&lang=js"
import style0 from "./live-reply.vue?vue&type=style&index=0&id=2e585745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e585745",
  null
  
)

export default component.exports